
// ══════════════════════════════════════════════════════════════════
// EN — reemplaza tu export const booking en el archivo de inglés
// ══════════════════════════════════════════════════════════════════
export const booking = {
  createBooking: "Create booking",
  detailsTitle: "Booking details",
  createdOn: "created on",
  statusBooked: "Booked",
  processing: "Processing...",
  reject: "Reject",
  cancelled: "Booking cancelled",
  guests: "Guests",
  nights: "Nights",
 
  responsibleTitle: "Booking Responsible",
  name: "Name",
  email: "Email",
  emailNotProvided: "No email provided",
  phone: "Phone",
  phoneNotProvided: "No phone provided",
  replyWhatsapp: "Reply on WhatsApp",
  notes: "Note",
  notesEmpty: "No note",
  notesPlaceholder: "Internal booking notes (e.g. late arrival, crib, allergies…)",
  notesEdit: "Edit note",
  notesSave: "Save",
  notesCancel: "Cancel",
  notesSaved: "Note updated",
  notesSaveError: "Could not save the note",
 
  amountTitle: "Reservation Amount",
 
  // Menu buttons & states
  validatingLink: "Validating link...",
  sendPaymentLink: "Send payment link",
  copyPaymentLink: "Copy payment link",
  sendingPaymentLink: "Sending payment link…",
  whatsappSent: "Payment link sent via WhatsApp.",
  whatsappSentFallback: "Template failed to send. WhatsApp opened manually.",
  freeReservationInfo: "Free reservation - No payment required",
  stripeNotConfigured: "Stripe not configured",
  changePaymentStatus: "Change payment status",
 
  // Amount status
  amountStatus: "Amount status",
  paymentPending: "Payment pending",
  paid: "Paid",
  rejected: "Rejected",
  refunded: "Refunded",
  partial: "Partial payment",
 
  // Totals
  subtotal: "Subtotal:",
  totalDiscounts: "Total discounts:",
  totalTaxes: "Total taxes:",
  total: "Total:",
 
  // Payment status modal
  changePaymentStatusHeader: "Change payment status",
  paymentStatusLabel: "Payment status",
  select: "Select",
  pending: "Pending",
  paidShort: "Paid",
  close: "Close",
  saveChanges: "Save changes",
 
  // Toastr / Messages
  paymentUrlSuccess: "Payment URL generated successfully",
  paymentUrlError: "Error generating payment URL",
 
  linkGenerated: "Payment link generated successfully",
  linkRegenerated: "Payment link updated due to price changes",
  linkPriceZero: "Cannot generate a payment link for free reservations ($0)",
  linkNoStripe: "The user has not configured Stripe to receive payments",
  linkNoProvider: "No payment provider configured (Stripe or Wompi)",  // ✅ NUEVA
  linkValidationFailed: "Cannot generate the payment link. Required data is missing.",
  linkValidateError: "Error validating the payment link",
  linkValid: "The payment link is valid",
 
  copySuccess: "The link was copied successfully",
  copied: "Copied!",
  copyError: "There was an error copying the link",
  error: "Error",
  statusUpdatedSuccess: "Status updated successfully",
  statusUpdatedError: "Error updating payment status",  // ✅ NUEVA
 
  // WhatsApp
  whatsappPayMessage: "Hi {name}! Here is your link to pay for your reservation: {url}",
 
  checkinsOf: "Check-ins on this reservation ({done} of {total})",
  completed: "Completed",
  pendings: "Pending",
  date: "Date",
  noCheckinsYet: "The guests for this reservation have not completed the check-in yet",
 
  alojamiento: "Accommodation",
};
 
